import { Box, Typography } from "@mui/joy";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { getDettaglioList } from "../../fetch";
import { capitalizeText } from "../../lib/utils";
import { ILotto } from "../../models";
import LottoImages from "./components/LottoImages";
import LottoInformations from "./components/LottoInformations";

export default function Item() {
  const { i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const onBack = () => navigate(-1);
  const lottoId = !!id ? parseInt(id) : null;
  const [lotto, setLotto] = useState<ILotto | null>(null);
  const nomeQualita = useMemo(
    () =>
      i18n.language === "en" && lotto?.qualita?.nomeEn
        ? lotto.qualita.nomeEn
        : lotto?.qualita?.nome ?? "",
    [lotto, i18n]
  );

  useEffect(() => {
    let mounted = true;
    getDettaglioList().then((result) => {
      if (mounted) {
        const dettagli = result.items.filter(
          (item) => item.idLotto === lottoId
        );
        dettagli.sort((itemA, itemB) => itemA.lastreDa - itemB.lastreA);
        const lotto = dettagli?.[0].lotto;
        if (lotto) {
          lotto.dettagli = dettagli;
          setLotto(lotto);
        }
      }
    });
    return () => {
      mounted = false;
    };
  }, [lottoId]);
  return (
    <Box sx={{ height: "100%", position: "relative" }}>
      <Box
        sx={{
          position: "absolute",
          height: "100%",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            px: "20px",
            height: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#36363d",
            "@media screen and (min-width: 1024px)": { px: "50px" },
          }}
        >
          <Box>
            <Typography sx={{}} level="h2">
              {capitalizeText(nomeQualita)}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            boxSizing: "border-box",
            width: "100%",
            overflow: "auto",
            pl: "20px",
            pb: 4,
            "@media screen and (min-width: 1024px)": {
              flexDirection: "row",
              pl: "50px",
            },
          }}
        >
          <Box
            sx={{
              py: 1,
              "@media screen and (min-width: 1024px)": {
                py: 0,
                display: "flex",
                height: "100%",
                width: "25%",
              },
            }}
          >
            <LottoInformations lotto={lotto} onBack={onBack} />
          </Box>
          <Box
            sx={{
              position: "relative",
              "@media screen and (min-width: 1024px)": { width: "75%" },
            }}
          >
            <LottoImages lotto={lotto} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
